const tails = new Map<string, Promise<void>>()

/**
 * addProductsToCart toma QuoteMutex (SELECT ... FOR UPDATE sobre quote_id_mask).
 * Dos clics en tiles distintos de la misma PLP disparan la mutation en paralelo
 * sobre el mismo cart id y el segundo request queda esperando el lock en PHP.
 * Esta cola deja un solo vuelo por carrito en la pestaña; un fallo no frena
 * al siguiente.
 */
export const enqueueCartMutation = <T>(
    cartId: string,
    task: () => Promise<T>
): Promise<T> => {
    const key = cartId || ''
    const previous = tails.get(key) ?? Promise.resolve()
    const result = previous.then(task, task)
    tails.set(
        key,
        result.then(
            () => undefined,
            () => undefined
        )
    )
    return result
}
